import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let LongTextDesign = class LongTextDesign extends Vue {
    render(h) {
        const that = this;
        return h('a-textarea', { props: {
                disabled: true,
                placeholder: that.$t('cloudpivot.form.dataitem.InputPlaceholder').toString(),
            } });
    }
};
LongTextDesign = tslib_1.__decorate([
    Component({ name: 'LongTextDesign' })
], LongTextDesign);
export default LongTextDesign;
